(() => {
  if (customElements.get('maytrix-review-cards')) return;
  customElements.define('maytrix-review-cards', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      const track = this.querySelector('.myx-customer-reviews__track');
      const cards = [...track.querySelectorAll('.myx-review-card')];
      const dialog = this.querySelector('dialog');
      let opener;
      cards.forEach(card => card.querySelector('button').addEventListener('click', e => {
        opener = e.currentTarget;
        const content = dialog.querySelector('.myx-review-dialog__content');
        content.replaceChildren(card.querySelector('img').cloneNode(true), card.querySelector('.myx-review-card__body').cloneNode(true));
        dialog.showModal();
      }, options));
      dialog.querySelector('.myx-review-dialog__close').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', e => {if (e.target === dialog) {const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom) dialog.close();}}, options);
      dialog.addEventListener('close', () => opener?.focus({preventScroll:true}), options);
      if (this.classList.contains('myx-customer-reviews--grid')) {
        const layout = () => {
          this.layoutFrame = null;
          if (!track.clientWidth) return;
          const style = getComputedStyle(track);
          const columns = Number(style.getPropertyValue('--review-columns')) || 5;
          const gap = parseFloat(style.getPropertyValue('--review-gap')) || 16;
          const heights = cards.map(card => Math.ceil(card.querySelector('button').getBoundingClientRect().height + 2));
          const bottoms = Array(columns).fill(1);
          track.classList.add('is-masonry');
          cards.forEach((card, index) => {
            // Keep the selected first five across the top, including Sarah fourth.
            const column = index % columns;
            card.style.gridColumn = String(column + 1);
            card.style.gridRow = `${bottoms[column]} / span ${heights[index]}`;
            bottoms[column] += heights[index] + gap;
          });
        };
        const scheduleLayout = () => {
          if (!this.layoutFrame) this.layoutFrame = requestAnimationFrame(layout);
        };
        this.resizeObserver = new ResizeObserver(scheduleLayout);
        this.resizeObserver.observe(track);
        cards.forEach(card => {
          this.resizeObserver.observe(card.querySelector('button'));
          card.querySelector('img').addEventListener('load', scheduleLayout, options);
        });
        document.fonts?.ready.then(() => {if (this.isConnected) scheduleLayout();});
        scheduleLayout();
      }
      const controls = this.querySelector('.myx-customer-reviews__controls');
      if (!controls) return;
      const dots = controls.querySelector('.myx-customer-reviews__dots');
      const prev = controls.querySelector('[data-review-prev]');
      const next = controls.querySelector('[data-review-next]');
      let pageSize = 4, current = 0, pages = 1;
      const go = page => {
        const card=cards[Math.min(page * pageSize,cards.length-1)];
        const left=card.offsetLeft-cards[0].offsetLeft;
        track.scrollTo({left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      };
      const update = () => {
        const step = cards.length>1 ? cards[1].offsetLeft-cards[0].offsetLeft : track.clientWidth;
        current = Math.min(pages-1,Math.round(track.scrollLeft/(step*pageSize)));
        if(track.scrollLeft>=track.scrollWidth-track.clientWidth-2) current=pages-1;
        [...dots.children].forEach((dot,i)=>dot.setAttribute('aria-current',String(i===current)));
        prev.disabled=current===0;next.disabled=current===pages-1;
      };
      const resize = () => {
        if (!track.clientWidth || !cards.length) return;
        const step=cards.length>1 ? cards[1].offsetLeft-cards[0].offsetLeft : track.clientWidth;
        pageSize=Math.max(1,Math.round(track.clientWidth/step));pages=Math.ceil(cards.length/pageSize);
        controls.hidden=pages<=1;dots.replaceChildren();
        for(let i=0;i<pages;i++){const dot=document.createElement('button');dot.type='button';dot.setAttribute('aria-label',`Review page ${i+1}`);dot.addEventListener('click',()=>go(i),options);dots.append(dot);}
        update();
      };
      prev.addEventListener('click',()=>go(Math.max(0,current-1)),options);
      next.addEventListener('click',()=>go(Math.min(pages-1,current+1)),options);
      track.addEventListener('scroll',update,{...options,passive:true});
      track.addEventListener('keydown',e=>{if(e.target!==track)return;if(e.key==='ArrowRight'){e.preventDefault();go(Math.min(pages-1,current+1));}if(e.key==='ArrowLeft'){e.preventDefault();go(Math.max(0,current-1));}},options);
      this.resizeObserver=new ResizeObserver(resize);this.resizeObserver.observe(track);resize();
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;this.resizeObserver?.disconnect();cancelAnimationFrame(this.layoutFrame);this.layoutFrame=null;}
  });
})();
